import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ListItem, TaskAddIcon, useMenuContext } from "@activecollab/components";
import PropTypes from "prop-types";
import { useConversationContentContext } from "../../../../context/index.jsx";
import { CREATE_TASK_MODE } from "../../index.jsx";

export const CreateTaskOption = ({ messageId }) => {
  const { t } = useTranslation();

  const { setOpen } = useMenuContext();
  const { setMode, onChangeSelectedMessage } = useConversationContentContext();

  const handleClick = useCallback(() => {
    if (typeof setMode === "function") {
      setMode(CREATE_TASK_MODE);
      onChangeSelectedMessage(messageId, true);
    }
    if (typeof setOpen === "function") {
      setOpen(false);
    }
  }, [messageId, onChangeSelectedMessage, setMode, setOpen]);

  return (
    <ListItem onClick={handleClick}>
      <TaskAddIcon className="tw-mr-2 fill-900" /> {t("Create Task")}
    </ListItem>
  );
};

CreateTaskOption.propTypes = {
  messageId: PropTypes.number.isRequired,
};
